import { useGetVehicleDetail } from './useGetVehicleDetail'

export const vehicle = {
  getVehicleDetail: useGetVehicleDetail,
}
